






















































import { createComponent, ref, watch, reactive } from "@vue/composition-api";
import {
  Decision,
  decisionResource,
  DecisionState,
} from "@megarax/client/src/resources/Decision";
import { VueConstructor } from "vue";
import { IncompleteResourceItem } from "@megarax/client/src/resources/ResourceItem";
import {
  StringInput,
  LabeledOptionSelectInput,
} from "@/components/form/InputFields";

import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";
import DecisionItemView from "./DecisionItemView";
import DecisionCardHeader from "./DecisionCardHeader.vue";

interface Props {}

export default createComponent<Props>({
  components: {
    StringInput,
    LabeledOptionSelectInput,
    ResourceItemTable,
    DecisionItemView,
    DecisionCardHeader,
  },
  name: "DecisionList",
  props: {},
  setup(props) {
    const tableRef = ref(null);

    const filters = reactive({
      state: [DecisionState.awaiting],
      withMyVote: undefined,
      withAnyVote: undefined,
    });

    function onRowClick(row: any, column: any, event: any) {
      (tableRef.value as any).tableRef.toggleRowExpansion(row);
    }

    return {
      tableRef,
      DecisionState,
      fetch,
      filters,
      onRowClick,
      resource: decisionResource,
    };
  },
});
